import React from 'react';
import styles from './CustomerSearchBar.module.css';

interface CustomerSearchBarProps {
  query: string;
  onQueryChange: (q: string) => void;
  priority: string;
  onPriorityChange: (p: string) => void;
  status: string;
  onStatusChange: (s: string) => void;
}

export const CustomerSearchBar: React.FC<CustomerSearchBarProps> = ({
  query, onQueryChange, priority, onPriorityChange, status, onStatusChange,
}) => {
  return (
    <div className={styles.bar}>
      <div className={styles.searchWrap}>
        <svg viewBox="0 0 24 24" fill="currentColor" className={styles.searchIcon}>
          <path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
        </svg>
        <input
          className={styles.input}
          placeholder="Search customers / orders / subject..."
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
        />
      </div>
      <select className={styles.filter} value={priority} onChange={(e) => onPriorityChange(e.target.value)}>
        <option value="All">All Priorities</option>
        <option value="Critical">Critical</option>
        <option value="High">High</option>
        <option value="Medium">Medium</option>
        <option value="Low">Low</option>
      </select>
      <select className={styles.filter} value={status} onChange={(e) => onStatusChange(e.target.value)}>
        <option value="All">All Statuses</option>
        <option value="Open">Open</option>
        <option value="In Progress">In Progress</option>
        <option value="Waiting">Waiting</option>
        <option value="Resolved">Resolved</option>
        <option value="Closed">Closed</option>
      </select>
    </div>
  );
};
